export default function (
    v1: unknown,
    operator: '==' | '!=' | '===' | '<' | '<=' | '>' | '>=' | '&&' | '||',
    v2: unknown
): boolean | null {
    switch (operator) {
        case '==':
            return v1 == v2;
        case '!=':
            return v1 != v2;
        case '===':
            return v1 === v2;
        case '<':
            return Number(v1) < Number(v2);
        case '<=':
            return Number(v1) <= Number(v2);
        case '>':
            return Number(v1) > Number(v2);
        case '>=':
            return Number(v1) >= Number(v2);
        case '&&':
            return Boolean(v1) && Boolean(v2);
        case '||':
            return Boolean(v1) || Boolean(v2);
        default:
            return null;
    }
}
